<template>
    <div v-if="isDesktop">
        <Fancybox class="grid-container" :options="{ Carousel: { infinite: true }}">
            <div class="grid-item" :class="{ 'grid-item--single' : index == 0 }" v-for="(media, index) in filteredMedia" :key="index">
                <template v-if="video && index == 0">
                    <a data-fancybox="gallery" :href="media.conversionUrls.enlarged" class="image-container">
                        <img :src="(media.conversionUrls.full_width)" />
                        <span class="magnify" :class="{ 'd-hover': index != 0 }"><i class="fal fa-search-plus"></i></span>
                        <span class="sash" v-if="data.custom_sash != null && data.custom_sash != ''">{{ data.custom_sash }}</span>
                    </a>
                    <a data-fancybox="gallery"
                       :href="`https://www.youtube.com/watch?v=${video}`"
                       class="play-button">
                       <i class="fal fa-play-circle"></i>
                    </a>
                </template>
                <a v-else data-fancybox="gallery" :href="media.conversionUrls.enlarged">
                    <span class="magnify" :class="{ 'd-hover': index != 0 }"><i class="fal fa-search-plus"></i></span>
                    <span class="sash" v-if="index == 0 && data.custom_sash != null && data.custom_sash != ''">{{ data.custom_sash }}</span>
                    <img v-if="index == 0" :src="(media.conversionUrls.full_width)" />
                    <img v-if="index > 0" :src="(media.conversionUrls.thumb)" />
                </a>
            </div>
        </Fancybox>
    </div>
    <div v-else>
        <FancyboxCarousel class="f-carousel" :options="{ Carousel: { infinite: true }}">
            <div class="f-carousel__slide" v-for="(media, index) in filteredMedia" :key="index" data-fancybox="gallery"
                :data-thumb-src="media.conversionUrls.thumb" :data-src="media.conversionUrls.enlarged">
                <div class="image-container">
                    <span class="sash" v-if="index == 0 && data.custom_sash != null && data.custom_sash != ''">{{ data.custom_sash }}</span>
                    <img :src="(media.conversionUrls.main)" />
                    <a v-if="video && index == 0"
                       data-fancybox="gallery"
                       :href="`https://www.youtube.com/watch?v=${video}`"
                       class="play-button">
                        <i class="fal fa-play-circle"></i>
                    </a>
                </div>
            </div>
        </FancyboxCarousel>
    </div>
</template>

<script>
    import Fancybox from './FancyboxWrapper.vue';
    import FancyboxCarousel from './FancyboxCarouselWrapper.vue';

    export default {
        props: {
            data: {
                type: Object,
                default: {},
                required: true,
            },
            video: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                isDesktop: true
            };
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.checkScreenSize);
        },
        methods: {
            hasAccessories(mediaArray) {
                return mediaArray.some(media => media.id === 2);
            },
            checkScreenSize() {
                this.isDesktop = window.innerWidth >= 768;
            },
        },
        computed: {
            filteredMedia() {
                return this.data.media.filter(media => media.collection_name === 'product');
            },
        },
        components: {
            Fancybox,
            FancyboxCarousel
        },
    };

</script>
